// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { randomUUID } from "./uuidUtils.common.js";
